// DokumentEintragAktionen.tsx — an jedem Dokumenteintrag der Kontaktanlage:
// die aus dem Scan zum Ablegen vorgemerkte Datei (mit Entfernen).
//
// Bis 02.10.2026 stand hier auch „Datei hochladen". Auf Wunsch des Users
// entfernt — Dokumente kommen über „Dokumente scannen / hochladen" oben.
//
// Bis 02.10.2026 stand hier zusätzlich „<Art> scannen". Er öffnete denselben
// Dialog wie „Dokumente scannen / hochladen" über der Liste — der Ausweis-Scan
// stand damit doppelt da. Gescannt wird jetzt nur noch über den Knopf oben;
// das Ziel wählt dokumentScanVerteilen selbst.
//
// Scannen und Ablegen bleiben bewusst getrennt: Der Scan liest und schlägt
// vor, speichert aber nichts (beim Ausweis ist das Pflicht, § 20 PAuswG). Das
// Ablegen ist ein eigener, sichtbarer Schritt.

import * as React from "react";
import { makeStyles, shorthands } from "@fluentui/react-components";
import { REFINED } from "../../risikoanalyseStep/tokens";

const useStyles = makeStyles({
  zeile: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "8px",
  },
  datei: {
    fontFamily: REFINED.fontUI,
    fontSize: "0.82rem",
    color: REFINED.ink2,
    display: "inline-flex",
    alignItems: "center",
    columnGap: "6px",
  },
  entfernen: {
    appearance: "none",
    ...shorthands.border("0"),
    backgroundColor: "transparent",
    color: REFINED.err,
    cursor: "pointer",
    fontSize: "0.9rem",
    lineHeight: 1,
    padding: "2px 4px",
  },
});

export interface DokumentEintragAktionenProps {
  /** Dokumentart, z. B. „Führerschein" — für Beschriftung und Titel. */
  art: string;
  /** Name der zum Ablegen vorgemerkten Datei (aus dem Scan), falls vorhanden. */
  dateiName?: string;
  onDateiEntfernen?: () => void;
}

export const DokumentEintragAktionen: React.FC<DokumentEintragAktionenProps> = ({
  art,
  dateiName,
  onDateiEntfernen,
}) => {
  const s = useStyles();
  if (!dateiName) return null;

  return (
    <div className={s.zeile}>
      <span className={s.datei} title={`${art}: wird beim Speichern in der Akte abgelegt`}>
        Datei: {dateiName}
        {onDateiEntfernen && (
          <button
            type="button"
            className={s.entfernen}
            onClick={onDateiEntfernen}
            aria-label={`Datei ${dateiName} entfernen`}
            title="Datei entfernen"
          >
            ✕
          </button>
        )}
      </span>
    </div>
  );
};
